<template>
<div id="agent-billing">
	<ul class="title-nav">
		<li>
			<div v-on:click="routeBack()" class="back-btn">
				<i class="material-icons md-18">keyboard_arrow_left</i>
			</div> 
			
			<div class="title-label"><i class="material-icons md-18">credit_card</i> BILLING</div>
		</li>
	</ul>

	<div class="category" v-if="cards && cards.length > 0">
		<div class="category-title">CREDIT CARDS</div>
		<div v-for="(card, index) in cards" class="property-row position-relative overflow-visible">
			*{{card.last4}} <small class="text-muted">EXP {{card.exp_month}}/{{card.exp_year | yearShort}}</small>
			<i v-on:click="cardRemoveToggle(card.id)" class="material-icons md-18 icon-gray close-icon float-right">close</i>
			<a href="javascript:" v-if="cardRemove === card.id" v-on:click="cardRemoveConfirmed(card.id)" 
				class="btn btn-danger btn-sm remove-btn float-right">REMOVE</a>
		</div>
		<div v-if="mode == 'view'" class="property-row">
			<button v-on:click="addShow" class="btn btn-light btn-sm float-right">Add Card</button>
		</div>
	</div>
	<form v-if="mode === 'add' || (!cards || cards.length < 1)" v-on:submit.prevent="cardAdd" class="mt-2">
		<div class="form-group mb-0">
			<div class="form-control" v-bind:class="{'is-invalid':error && error.card}">
				<div class="card-mount">
				</div>
			</div>
			<div class="invalid-feedback">
				{{error && error.card}}
	      </div>
		</div>
		<div class="property-row">
			<button v-if="cards && cards.length > 0" v-on:click="addCancel" class="btn btn-light">Cancel</button>
			<button class="btn btn-dark float-right" type="submit">Add Card</button>
		</div>
	</form>

	<contentLoading :loading="loading"/>
	<contentAlert :alert="alert" :handleClose="handleAlertClose"/>
</div>

</template>

<script>

import config from '../../config';
import contentAlert from '../content/content-alert';
import contentLoading from '../content/content-loading';

var stripe = Stripe(config.stripe.publicKey);

export default {
	components:{
		contentAlert,
		contentLoading
	},
	computed:{
		cards: function(){
			if (!this.$store.state.stripe || !this.$store.state.stripe.customer || !this.$store.state.stripe.customer.sources)
				return null;
			return this.$store.state.stripe.customer.sources.data;
		}
	},
	data: function(){
		return {
			alert:null,
			card:null,
			error:null,
			mode:'view',
			loading:true,
			cardFormBound:false,
			cardRemove:null,
			stripeToken:null,
		}
	},
	mounted:async function(){
		try {
			this.loading = true;
			await this.$store.dispatch('AGENT_CUSTOMER_GET', {});
			this.bindCardForm();
			this.loading = false;

			console.log('cards:',this.cards);
		} catch(e){
			this.loading = false;
		}
	},
	props: {
		agent:{
			type:Object
		},
	},
	methods:{
		bindCardForm:function(){
			if (this.cardFormBound) return;
			var elements = stripe.elements();

			var style = {
				base: {
					fontSize: '16px',
					color: "#495057",
					lineHeight:'26px'
				}
			};

			this.card = elements.create('card', {style: style});
			this.card.mount('.card-mount');
			this.cardFormBound = true;
		},
		routeBack:function(){
			this.$router.push({
				name:'agent',
			});
		},
		deleteShow:function(){

		},
		addCancel:function(){
			this.mode = 'view';
			this.cardFormBound = false;
		},
		addShow:function(){
			this.mode = 'add';
			setTimeout(()=>{
				this.bindCardForm();
			},1);
		},
		cardRemoveToggle:function(cardId){
			if (this.cardRemove === cardId) this.cardRemove = null;
			else this.cardRemove = cardId;
		},
		cardRemoveConfirmed:async function(cardId){
			try {
				this.loading = true;
				await this.$store.dispatch('STRIPE_CARD_REMOVE', {cardId:cardId});
				await this.$store.dispatch('AGENT_CUSTOMER_GET', {});
				this.alert = 'card removed';
				this.loading = false;
			} catch(e){
				this.loading = false;
			}
		},
		cardAdd:async function(){
			this.loading = true;
			try{
				const result = await stripe.createToken(this.card);
				if (result.error) {
					throw new Error(result.error.message);
				} else {
					this.stripeToken = result.token;
					console.log('stripeToken:',this.stripeToken);
					await this.$store.dispatch('STRIPE_CARD_ADD', {stripeToken:result.token});
					await this.$store.dispatch('AGENT_CUSTOMER_GET', {});
					this.alert = 'card added';
					this.addCancel();
					this.loading = false;
				}
			} catch(e){
				this.loading = false;
			}
		},
		handleAlertClose:function(){
			this.alert = null;
		}
	},
	watch:{
	}
}

</script>
<style>
#agent-billing .remove-btn{position:absolute;right:24px;top:6px;padding:2px 8px;font-size:11px;}

</style>


// WEBPACK FOOTER //
// src/components/agent/agent-billing.vue